import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs';
import { ITodoState, todoFacadeBase } from './todo.state';
import { TodoService } from './todo.service';
import { Todo } from './todo.model';
import { StatutTodoEnum } from './statut.todo.enum';

@Injectable()
export class TodoFacade extends todoFacadeBase  {


    constructor(_store: Store<ITodoState>, private _todoService: TodoService) {
        super( Todo, _store);
    }
    
    getTodoByDate(body: { date: string, userIds?: number[], statut?: StatutTodoEnum[], name?: string }): Observable<any> {
        return this._todoService.getTodoByDate(body);
    }

    repeatTodo(body: { }): Observable<any> {
        return this._todoService.repeatTodo(body);
    }
   
    getTodoFromToday(body: { userId : number }): Observable<any> {
        return this._todoService.getTodoFromToday(body);
    }
    
    getTodoReport(body: { userId: number, startDate: string, endDate: string }): Observable<any> {
        return this._todoService.getTodoReport(body);
    }
}
